import { Flex, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

export default function InfoPredix() {
  const { t } = useTranslation();
  return (
    <Flex
      direction={"column"}
      gap="0.6875rem"
      w={{ base: "100%", 991: "77%" }}
      maw="75rem"
      p={{ base: "1rem 0.5rem", 991: "1.25rem 1.875rem" }}
      bg={`linear-gradient(90deg,#FFFFFf20 10%, #99999900 )`}
      style={{
        borderRadius: "0.75rem",
        borderLeft: `1px solid`,
        borderBottom: `1px solid`,
        borderTop: `1px solid`,
        borderColor: "#ffffff20",
        WebkitBackdropFilter: "blur(50px)",
        backdropFilter: "blur(2px)",
      }}
    >
      <Text
        fz={{ base: "1.25rem", 991: "1.625rem" }}
        fw={700}
        color="basic.0"
        ff="Inter"
        lh="155%"
      >
        {t("marketplace.predix.subtitle")}
      </Text>
      <Text
        fz={{ base: "1rem", 991: "1.25rem" }}
        fw={400}
        color="basic.0"
        ff="Inter"
        lh="155%"
      >
        {t("marketplace.predix.description")}
      </Text>
    </Flex>
  );
}
